export enum PostHogFeatureFlags {
  SIMPLIFIED_PHISHING_PLANNING_SCREEN = 'simplified-phishing-planning-screen',
  EXPORT_TO_LMS = 'lms-export',
  RECON_AI_GENERATED_CAMPAIGN_TEMPLATE = 'recon-ai-generated-campaign-template',
  ENTRA_ID_FIELD_MAPPING = 'entra-id-field-mapping',
  SIMPLIFIED_SC_SURVEY_PLANNER = 'simplified-sc-survey-planner',
  USER_DOMAIN_VERIFICATION = 'user-domain-verification',
  FREE_TRIAL_LIFECYCLE_V2 = 'free-trial-lifecycle-v2',
  PHISHING_SIMULATION_FOLLOW_UP = 'phishing-simulation-follow-up',
  TRAINING_VARIABLES = 'training-variables',
  FREE_TRIAL_PLATFORM_RESTRICTIONS = 'free-trial-platform-restrictions',
  FREE_TRIAL_PENDING_USERS = 'free-trial-pending-users',
}

export enum PostHogFeatureVariant {}

export enum PostHogCustomEvent {
  USER_CLICKED_CONTENT_HIGHLIGHTED_CONTENT = 'user_clicked_content_highlighted_content',
  COURSE_COMPLETED = 'course_completed',
  COURSE_COMPLETED_REQUEST_SUCCESS = 'course_completed_request_success',
  USER_LOGGED_IN = 'user_logged_in',
  ACCESSIBILITY_ICON_CLICKED = 'accessibility_icon_clicked',

  // I have no clue what these are for and neither does the PO, so I'm marking them as deprecated just in case.
  /** @deprecated */ COURSE_COMMIT = 'course_commit ',
}

export enum PostHogEvent {
  PAGE_VIEW = '$pageview',
}
